import { Injectable, Type } from '@angular/core';
import { XMLElementBaseComponent } from './base';
import { ActionComponent } from './components/action.component';
import { ChapterLinkComponent } from './components/chapter-link.component';
import { DesignationComponent } from './components/designation.component';
import { EboLinkComponent } from './components/eboLink.component';
import { ExplanationComponent } from './components/explanation.component';
import { ExploBlockComponent } from './components/explo-block.component';
import { GTextComponent } from './components/gtext.component';
import { HintComponent } from './components/hint.component';
import { ImageTitleComponent } from './components/image-title.component';
import { ImageComponent } from './components/image.component';
import { ImgLinkComponent } from './components/imageLink';
import { InsideImageComponent } from './components/inside-image.component';
import { LegendComponent } from './components/legend.component';
import { VwListComponent } from './components/list.component';
import { ParagraphComponent } from './components/paragraph.component';
import { PointComponent } from './components/point.component';
import { PosComponent } from './components/pos.component';
import { PosSlpComponent } from './components/posSlp.component';
import { RepairNumberComponent } from './components/repair-number.component';
import { SubchapterComponent } from './components/subchapter.component';
import { SubPointComponent } from './components/subpoint.component';
import { TableBlockComponent } from './components/table/table-block.component';
import { TableComponent } from './components/table/table.component';
import { TitleComponent } from './components/title.component';
import { ToolVwListComponent } from './components/tool-list.component';
import { WarningComponent } from './components/warning.component';
import { WDImageComponent } from './components/wd-image.component';

@Injectable({
  providedIn: 'root',
})
export class XMLComponentResolverService {
  private componentMap: { [key: string]: Type<XMLElementBaseComponent> } = {
    absatz: ParagraphComponent,
    achtung: WarningComponent,
    aufzaehlg: VwListComponent,
    bedingung: ExplanationComponent,
    bez: DesignationComponent,
    'bild-titel': ImageTitleComponent,
    bild: ImageComponent,
    bt: ExplanationComponent,
    'ebo-link': EboLinkComponent,
    entry: GTextComponent,
    erlaeutrg: ExplanationComponent,
    'explo-block': ExploBlockComponent,
    'ext-dok': ChapterLinkComponent,
    'ext-rl': ChapterLinkComponent,
    'ext-titel': ChapterLinkComponent,
    'folge-und-quelle': ExplanationComponent,
    folge: ExplanationComponent,
    // formel: ParagraphComponent,
    g: GTextComponent,
    handlung: ActionComponent,
    hinweis: HintComponent,
    'im-bild': InsideImageComponent,
    'leg-explo-m': LegendComponent,
    'leg-explo': LegendComponent,
    'leg-m': LegendComponent,
    leg: LegendComponent,
    'leg-slp': LegendComponent,
    massnahme: ExplanationComponent,
    num: ExplanationComponent,
    // 'pos-num': PosNumComponent,
    pos: PosComponent,
    // possbile: bauteil, verbindung
    'pos-slp': PosSlpComponent,
    punkt: PointComponent,
    quelle: ExplanationComponent,
    'qv-bild-titel': ExplanationComponent,
    'rep-num': RepairNumberComponent,
    'slp-bild': WDImageComponent,
    titel: TitleComponent,
    'u-kap': SubchapterComponent,
    'u-punkt': SubPointComponent,
    vp: ImgLinkComponent,
    warnhinweis: WarningComponent,
    'wz-liste': ToolVwListComponent,
    wz: ExplanationComponent,
    zitat: ExplanationComponent,

    'tab-block': TableBlockComponent,
    tabelle: TableComponent,
    // colspec: GTextComponent,
    // tbody: GTextComponent,
    // tgroup: GTextComponent,
    // row: GTextComponent,

    // TODO:
    // Handbuch reference:
    // 'ext-igg': BookReferenceComponent,

    // Chapter:
    // kap with title, absatz, ext-igg
    // kap uses more attributes, like id, motor-kb, typen-bez, verkaufstyp

    // TODO: FIXME: Link is not yet working
    // 'qv-kap': QVChapterComponent,
  };

  getComponent(tag: string): Type<XMLElementBaseComponent> | null {
    return this.componentMap[tag] || null;
  }

  hasComponent(tag: string): boolean {
    return !!this.componentMap[tag];
  }
}
